<div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto">
  <div style="padding-left: 15px;" class="col-12 no-gutters">
    <app-layout-header class="col-12 no-gutters" [isLandingPage]="true"></app-layout-header>
  </div>
  <div class="mt-2 col-12">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer-layout></app-footer-layout>
